import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toThunkRejectValue } from "../../../../Common/isRequestCanceled";
import {
  BASE_URL,
  REPORTS_BASE_URL,
  SALES_REPORT_LIST_REPORTS,
  GET_TOP_CATEGORY_BY_QUANTITY_SOLD,
  GET_TOP_CATEGORY_BY_SALES_AMOUNT,
  GET_TOP_CATEGORY_SALES_REPORT_LIST,
  SALES_REPORT_LIST,
} from "../../../../Constants/Config";
import { useAuthDetails } from "../../../../Common/cookiesHelper";
const initialState = {
  loading: false,
  SalesReportData: [],
  successMessage: "",
  error: "",
  activeSalesReportRequestId: null,
  qtyLoading: false,
  qtyData: [],
  qtyError: "",
  salesAmtLoading: false,
  salesAmtData: [],
  salesAmtError: "",
  reportListLoading: false,
  reportListData: [],
  reportListError: "",
  exportReportPayload: {},
};
let cancelTokenSource;
let cancelTokenSource1;
let cancelTokenSource2;
let cancelTokenSource3;

// Generate pening , fulfilled and rejected action type
export const fetchSalesReportData = createAsyncThunk(
  "SalesReportList/fetchSalesReportData.",
  async (data, { rejectWithValue }) => {
    const { userTypeData } = useAuthDetails();
    if (cancelTokenSource) {
      cancelTokenSource.cancel("Previous request canceled");
    }
    cancelTokenSource = axios.CancelToken.source();
    try {
      const { token, ...otherUserData } = userTypeData;
      // console.log(BASE_URL + VENDORS_SALES_REPORT)
      const response = await axios.post(
        // BASE_URL + SALES_REPORT_LIST,
        REPORTS_BASE_URL + SALES_REPORT_LIST_REPORTS,
        { ...data, ...otherUserData },
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          cancelToken: cancelTokenSource.token,
        }
      );
      // console.log(response)
      if (response.data.status === true) {
        // console.log(response.data.sales_data
        //     )
        return response.data.result;
      }
    } catch (error) {
      // throw new Error(error.response.data.message);
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);
// fetch (Category) Sales Report ()
export const fetchCategoryQtySoldSalesReport = createAsyncThunk(
  "SalesReportList/fetchCategoryQtySoldSalesReport.",
  async (data, { rejectWithValue }) => {
    const { userTypeData } = useAuthDetails();
    if (cancelTokenSource1) {
      cancelTokenSource1.cancel("Previous request canceled");
    }
    cancelTokenSource1 = axios.CancelToken.source();
    try {
      const { token, ...otherUserData } = userTypeData;
      const response = await axios.post(
        BASE_URL + GET_TOP_CATEGORY_BY_QUANTITY_SOLD,
        { ...data, ...otherUserData },
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          cancelToken: cancelTokenSource1.token,
        }
      );
      return response.data;
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);
export const fetchCategorySalesAmountSalesReport = createAsyncThunk(
  "SalesReportList/fetchCategorySalesAmountSalesReport.",
  async (data, { rejectWithValue }) => {
    const { userTypeData } = useAuthDetails();
    if (cancelTokenSource3) {
      cancelTokenSource3.cancel("Previous request canceled");
    }
    cancelTokenSource3 = axios.CancelToken.source();
    try {
      const { token, ...otherUserData } = userTypeData;
      const response = await axios.post(
        BASE_URL + GET_TOP_CATEGORY_BY_SALES_AMOUNT,
        { ...data, ...otherUserData },
        {
          // throw new Error(error.response.data.message);
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          cancelToken: cancelTokenSource3.token,
        }
      );
      return response.data;
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);
export const fetchCategorySalesReportList = createAsyncThunk(
  "SalesReportList/fetchCategorySalesReportList.",
  async (data, { rejectWithValue, signal }) => {
    const { userTypeData } = useAuthDetails();
    if (cancelTokenSource2) {
      cancelTokenSource2.cancel("Previous request canceled");
    }
    cancelTokenSource2 = axios.CancelToken.source();
    try {
      const { token, ...otherUserData } = userTypeData;
      // console.log(BASE_URL + VENDORS_SALES_REPORT)
      const response = await axios.post(
        BASE_URL + GET_TOP_CATEGORY_SALES_REPORT_LIST,
        { ...data, ...otherUserData },
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          cancelToken: cancelTokenSource2.token,
        }
      );
      const categorySalesReportListUpdated = response?.data?.category_data.map(
        (obj) => ({
          ...obj,
          netSales: obj?.net_sales || 0,
          // (obj?.sale_amount || 0) - parseFloat(obj.discount_amt || 0)
          grossProfit: obj.gross_profit || 0,
          // (obj.sale_amount || 0) - parseFloat(obj.discount_amt || 0) - (obj.costs || 0)
          grossMargin:
            // obj?.costs > 0
            obj?.net_sales > 0
              ? ((obj.gross_profit || 0) / (obj.net_sales || 0)) * 100
              : 100,
          // (( (obj.gross_profit || 0) /(obj.costs || 0)) *100)
          // :100
          // grossMargin:
          // obj?.costs > 0
          //   ? (
          //       ((obj?.sale_amount || 0) - (obj?.discount_amt || 0) - (obj?.costs || 0)) /
          //       obj?.costs
          //     ) * 100
          //   : 100,
        })
      );
      return categorySalesReportListUpdated;
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);
const SalesReportSlice = createSlice({
  name: "SalesReportList",
  initialState,
  reducers: {
    updateStateOfCategory: (state, { payload }) => {
      state.SalesReportData = [];
      state.qtyData = [];
      state.salesAmtData = [];
      state.reportListData = [];
    },
    updateReportPayload: (state, { payload }) => {
      state.exportReportPayload = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSalesReportData.pending, (state, action) => {
      state.loading = true;
      state.activeSalesReportRequestId = action.meta.requestId;
    });
    builder.addCase(fetchSalesReportData.fulfilled, (state, action) => {
      if (state.activeSalesReportRequestId !== action.meta.requestId) return;
      state.loading = false;
      state.SalesReportData = action.payload;
      state.error = "";
      state.activeSalesReportRequestId = null;
    });
    builder.addCase(fetchSalesReportData.rejected, (state, action) => {
      if (state.activeSalesReportRequestId !== action.meta.requestId) return;
      state.loading = false;
      state.SalesReportData = {};
      state.error = action.error.message;
      state.activeSalesReportRequestId = null;
    });
    // top_category_by_qty_sold
    builder.addCase(fetchCategoryQtySoldSalesReport.pending, (state) => {
      state.qtyLoading = true;
    });
    builder.addCase(
      fetchCategoryQtySoldSalesReport.fulfilled,
      (state, action) => {
        state.qtyLoading = false;
        state.qtyData = action.payload.category_data;
        state.qtyError = "";
      }
    );
    builder.addCase(
      fetchCategoryQtySoldSalesReport.rejected,
      (state, action) => {
        state.qtyLoading = false;
        state.qtyData = {};
        state.qtyError = action.error.message;
      }
    );
    // top_category_by_sales_amt
    builder.addCase(fetchCategorySalesAmountSalesReport.pending, (state) => {
      state.salesAmtLoading = true;
    });
    builder.addCase(
      fetchCategorySalesAmountSalesReport.fulfilled,
      (state, action) => {
        state.salesAmtData = action.payload.category_data;
        state.salesAmtError = "";
        state.salesAmtLoading = false;
      }
    );
    builder.addCase(
      fetchCategorySalesAmountSalesReport.rejected,
      (state, action) => {
        state.salesAmtData = {};
        state.salesAmtError = action.error.message;
        state.salesAmtLoading = false;
      }
    );
    //category_sales_report_list
    builder.addCase(fetchCategorySalesReportList.pending, (state) => {
      state.reportListLoading = true;
    });
    builder.addCase(fetchCategorySalesReportList.fulfilled, (state, action) => {
      state.reportListData = action.payload;
      state.reportListError = "";
      state.reportListLoading = false;
    });
    builder.addCase(fetchCategorySalesReportList.rejected, (state, action) => {
      state.reportListData = {};
      state.reportListError = action.error.message;
      state.reportListLoading = false;
    });
  },
});

export const { updateStateOfCategory, updateReportPayload } =
  SalesReportSlice.actions;
export default SalesReportSlice.reducer;
